import React from 'react';
import { UserContext } from "../Providers/UserProvider";
import  { useContext, useState } from "react";
import { firestore } from '../firebase.js';
import iconUp from '../Images/iconUp.svg';
import iconDown from '../Images/iconDown.svg';
import '../Styles/Sass/Endorsements.scss';

function Endorsements(props){
  const [userEndorsed, setUserEndorsed] = React.useState({});
  const [indexOfEndorsed, setIndexOfIndorsed] = React.useState(0);

  React.useEffect(() => {
    getCurrentUserEndorsements();
  }, [props.user, props.endorsements]);

  //Get current user endorsed status for user of profile visiting
  const getCurrentUserEndorsements = () => {
    if (props.user) {
      firestore.collection('users').doc(props.user.uid).get()
        .then(res => {
          let userEndorsements = res.data().endorsed;
          let indexOfEndorsement = userEndorsements.findIndex(endorsed => {
            return endorsed.userId === props.profileId
          })
          if (indexOfEndorsement == -1) {
            let endorsedObject = {
              userId: props.profileId,
              endorsement1: 0,
              endorsement2: 0,
              endorsement3: 0,
              endorsement4: 0,
              endorsement5: 0,
              endorsement6: 0
            }
            userEndorsements.push(endorsedObject);
            let newIndex = userEndorsements.length - 1;
            firestore.collection('users').doc(props.user.uid).update({
              endorsed: userEndorsements
            })
              .then(res => {
                setUserEndorsed(endorsedObject);
                setIndexOfIndorsed(newIndex);
              })
              .catch(err => {
                console.log(err);
              })
          } else {
            setUserEndorsed(userEndorsements[indexOfEndorsement]);
            setIndexOfIndorsed(indexOfEndorsement);
          }
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      console.log('fail');
    }
  }

  //render endorsement cards
  const renderEndorsements = () => {
    if (props.endorsements) {
      const renderedElements = props.endorsements.map(endorsement => {
        return (
          <li className='endorseCard' key={endorsement.name}>
            <h3 className='endorseCard__title'>{endorsement.name}</h3>
            <div className='endorseCard__voteBox'>
              <button onClick={() => props.upvoteEndorse(endorsement.name)} className='endorseCard__button'>
                <img
                  className={
                    userEndorsed[endorsement.name] == 1 ?
                      'endorseCard__icon endorseCard__icon--voted' :
                      'endorseCard__icon'
                  }
                  src={iconUp}
                  alt="Up Arrow"
                />
              </button>
              <p className='endorseCard__voteCount'>{endorsement.up + endorsement.down}</p>
              <button onClick={() => props.downvoteEndorse(endorsement.name)} className='endorseCard__button'>
                <img
                  className={
                    userEndorsed[endorsement.name] == -1 ?
                      'endorseCard__icon endorseCard__icon--voted' :
                      'endorseCard__icon'
                  }
                  src={iconDown}
                  alt="Down Arrow"
                />
              </button>
            </div>
          </li>
        )
      })
      return renderedElements;
    }
  };

  return(
    <section className='endorsements'>
      <div className='endorsements__contentBox'>
        <h2 className='endorsements__title'>Endorsements</h2>
        <ul className='endorsements__list'>
        {renderEndorsements()}
        </ul>
      </div>
    </section>
  );
}
export default Endorsements;